// src/utils/auth.js

export const API_BASE_URL = 'https://youdemi-fullstack.onrender.com/api/v1';

export const AUTH_ENDPOINTS = {
    signIn: `${API_BASE_URL}/auth/signin`,
    signUp: `${API_BASE_URL}/auth/signup`,
    google: `${API_BASE_URL}/auth/google`,
    me: `${API_BASE_URL}/auth/me`
};

export const signInWithGoogle = () => {
    window.location.assign(AUTH_ENDPOINTS.google)
}